import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type ILeadStatusConfiguration, leadStatusConfigurationManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { type ILeadStatusState } from './types';

const LEAD_STATUS_CONFIGURATION_MODULE = 'leadStatusConfiguration';

const state: ILeadStatusState = {
    byStatus: new Map()
};

const dataObjectModule = getDataObjectsModule<ILeadStatusConfiguration>(leadStatusConfigurationManager, 3);
const searchModule = getSearchModule<ILeadStatusConfiguration>(leadStatusConfigurationManager);

const leadStatusConfigurationModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, getters, mutations });
store.registerModule(LEAD_STATUS_CONFIGURATION_MODULE, leadStatusConfigurationModuleInstance);

export { LEAD_STATUS_CONFIGURATION_MODULE };
